import { useMediaQuery, useTheme } from '@mui/material';
import { RiBarcodeLine } from '@remixicon/react';
import { useRouter } from '@tanstack/react-router';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useAuth, useIsMember } from 'src/auth';
import Link from 'src/components/atoms/Link';
import { AgButton } from 'src/components/ui';
import { useAiV2Enabled } from 'src/hooks/useAiV2Enabled';
import { FeatureFlagsClient, GLOBAL_APP_BAR_HEIGHT } from 'src/lib/constants';
import { buildAppHref } from 'src/lib/routing';
import AiChatButton from 'src/modules/ai/components/AiChatButton';
import { useAiInboxOnlyMode } from 'src/modules/ai-inbox/hooks/useAiInboxOnlyMode';
import { FeedbackButton, FeedbackDrawer } from 'src/modules/feedback';
import { GlobalSearchTrigger } from 'src/modules/globalSearch';
import { appLinks } from 'src/routing/appLinks';
import NotificationMenu from '../../components/containers/menus/NotificationMenu';
import { UserMenu } from '../../components/containers/menus/UserMenu';
import CreateNewButton from './CreateNewButton';
import { getEnvHeaderTheme } from './envHeaderTheme';

export { GLOBAL_APP_BAR_HEIGHT };

export default function SiteHeader() {
  const theme = useTheme();
  const router = useRouter();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const flags = useFlags();
  const aiV2 = useAiV2Enabled();
  const isMember = useIsMember();
  const { currentUser } = useAuth();
  const envTheme = getEnvHeaderTheme();
  const { locked: aiInboxOnly } = useAiInboxOnlyMode();

  const showMemberChrome = isMember && !aiInboxOnly;

  return (
    <header
      className="flex fixed border-b shadow-none top-0 left-0 right-0 px-6 items-center my-auto gap-4 md:gap-3"
      style={{
        zIndex: theme.zIndex.drawer + 1,
        height: GLOBAL_APP_BAR_HEIGHT,
        background: envTheme.background,
        borderBottomColor: envTheme.borderColor,
      }}
    >
      <Link
        {...appLinks.landing()}
        label={<img style={{ height: 28 }} src={isSmallScreen ? '/icon.svg' : '/logo.svg'} alt="Agriful" />}
      />
      {showMemberChrome && <GlobalSearchTrigger />}
      <div className="flex-1" />

      <div className="flex items-center gap-2 h-full">
        {showMemberChrome && <CreateNewButton />}
        {showMemberChrome && flags.scanPage && (
          <AgButton variant="ghost" href={buildAppHref(router, appLinks.scan())}>
            <RiBarcodeLine />
            Go to Scanning
          </AgButton>
        )}
        {isMember && <NotificationMenu />}
        {showMemberChrome && !aiV2 && <AiChatButton />}
        {showMemberChrome && flags[FeatureFlagsClient.CustomerFeedback] === true && <FeedbackButton />}
        {!!currentUser && <UserMenu />}
      </div>
      {showMemberChrome && flags[FeatureFlagsClient.CustomerFeedback] === true && <FeedbackDrawer />}
    </header>
  );
}
